import { z } from 'zod'

import { PrepareReceiveMessageEvent, ReceiveIfameMessageEventSchema, SendIframeMessageEventData, SendIframeMessageEventSchema } from './schema';
import { paths } from './paths';
import { IS_EMBEDDED } from './utils';
import { dispatchIframeEvent } from './dispatch';

// TODO: get the URLs from a config file
const ALLOWED_DEXT_URLS = [
    'http://localhost:3000',
    'https://commerce-integration.monolith.demo.dext.tools',
    'https://commerce-august.monolith.demo.dext.tools',
    'https://monolith.staging.dext.systems',
    'https://app.dext.dev',
    'https://app.dext.com',
]

type ReceiveIframeMessageEventData = z.infer<typeof ReceiveIfameMessageEventSchema>;

type IFrameEventSubscriberParams = {
    action: PrepareReceiveMessageEvent;
    callback: (payload?: ReceiveIframeMessageEventData) => void;
};

type MessageEventSubscriberCallback<
    TData extends ReceiveIframeMessageEventData,
> = (
    data: TData
) => void;

type MessageEventSubscriber<
    TActionName extends PrepareReceiveMessageEvent = PrepareReceiveMessageEvent,
    TData extends ReceiveIframeMessageEventData = ReceiveIframeMessageEventData,
> = {
    action: TActionName;
    callback: MessageEventSubscriberCallback<TData>;
};

function hasPayload(data: { action: string; payload?: unknown }): data is { action: string; payload: unknown } {
    return data.payload !== undefined;
}

let messageEventSubscribers: MessageEventSubscriber[] = []
function handleIframeEvent(event: MessageEvent) {
    if (!ALLOWED_DEXT_URLS.includes(event.origin)) return;

    const result = ReceiveIfameMessageEventSchema.safeParse(event.data);
    if (!result.success) return;
    const parsedData = result.data;

    messageEventSubscribers.forEach((subscriber) => {
        if (subscriber.action !== parsedData.action) return;

        if (hasPayload(parsedData)) {
            subscriber.callback({ action: parsedData.action, payload: parsedData.payload });
        } else {
            subscriber.callback({ action: parsedData.action });
        }
    });
}


function subscribeToIframeEvent<TAction extends PrepareReceiveMessageEvent = PrepareReceiveMessageEvent>(
    params: MessageEventSubscriber<TAction>
) {
    messageEventSubscribers.push({ action: params.action, callback: params.callback })
}

function unsubscribeFromIframeEvent(params: IFrameEventSubscriberParams) {
    messageEventSubscribers = messageEventSubscribers.filter(
        (subscriber) => subscriber.action !== params.action && subscriber.callback !== params.callback
    );
}

// @ts-expect-error ts(2551)
window.IS_EMBEDDED = IS_EMBEDDED;

if (IS_EMBEDDED) {
    window.addEventListener('message', handleIframeEvent);
    // @ts-expect-error ts(2551)
    window.dispatchIframeEvent = dispatchIframeEvent;
    // @ts-expect-error ts(2551)
    window.subcribeToIframeEvent = subscribeToIframeEvent;
    // @ts-expect-error ts(2551)
    window.unsubscribeFromIframeEvent = unsubscribeFromIframeEvent;

    subscribeToIframeEvent({
        action: 'NAVIGATE',
        callback: (data) => {
            if (data.action !== 'NAVIGATE') return;
            const payload = data.payload;
            let path: string = paths[payload.pathName]
            if (payload.hasOwnProperty('practiceCrn')) {
                path = path.replace(/{practice_crn}/g, (payload as any).practiceCrn)
            }
            if (payload.hasOwnProperty('clientCrn')) {
                path = path.replace(/{client_crn}/g, (payload as any).clientCrn)
            }
            if (payload.hasOwnProperty('identifier')) {
                path = path.replace(/{identifier}/g, (payload as any).identifier)
            }
            window.location.href = path
        }
    });

    document.addEventListener('click', (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        if (!target?.closest( ".btn-navigate")) {
            return
        }

        let payload
        if (target.dataset.link === 'INBOX') {
            // @ts-expect-error ts(2304)
            const crn = reduxStore.getState().user.crn
            payload = {
                pathName: 'INBOX',
                clientCrn: crn,
            } as const
        } else {
            payload = {
                pathName: 'HOMEPAGE',
            } as const
        }

        // @ts-expect-error ts(2304)
        const crn = reduxStore.getState().user.crn
        dispatchIframeEvent({ action: 'NAVIGATE', payload });
    });

    document.addEventListener('click', (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        if (target.closest( ".btn-toast")) {
            // @ts-expect-error ts(2304)
            const name = reduxStore.getState().user.name
            dispatchIframeEvent({ action: 'SHOW_TOASTER', payload: {
                title: `Hello, ${name}`,
                body: 'This got sent from Dext Commerce',
                type: 'success',
            } });
        }

        if (target.closest( ".btn-show-overlay")) {
            dispatchIframeEvent({ action: 'SHOW_OVERLAY'});
        }
    });
}
